'use client';

import { useMemo } from 'react';
import {
  AssetType,
  getTradeContentByTypeName,
  isBpfsAsset,
  NonNullableTransactionData,
} from '../../utils';
import { SuccessModal } from '../../../common';
import { ModalComponent } from '../../../common/components/ModalDrawerContext/ModalDrawerContext';
import { revalidatePortfolioAndTransactions } from '../../../common/gqlActions/nextCache/revalidatePortfolioAndTransactions';
import { useClientTranslation, useClientLocale } from '@bts-web/utils-lokalise';

export const FinishTradeStatusModal: ModalComponent<{
  transactionData: NonNullableTransactionData;
  hasTaxOfflineWarning: boolean;
}> = ({ transactionData, onClose, hasTaxOfflineWarning }) => {
  const { t } = useClientTranslation();

  const currentLocale = useClientLocale();

  const { status, sourceAsset } = transactionData ?? {
    status: 'FAILED',
  };

  const content = useMemo(
    () =>
      getTradeContentByTypeName({
        translationUtil: t,
        locale: currentLocale,
        transactionData,
        hasTaxOfflineWarning,
      }),
    [status],
  );

  const isBpfs = isBpfsAsset(
    (sourceAsset
      ? sourceAsset?.__typename
      : transactionData?.asset?.__typename) as AssetType,
  );

  const handleClose = () => {
    revalidatePortfolioAndTransactions();

    onClose();
  };

  return (
    <SuccessModal
      logo={{
        url: transactionData?.asset?.logoUrl as string,
        name: transactionData?.asset?.name as string,
      }}
      sourceLogo={
        sourceAsset
          ? {
              url: sourceAsset.logoUrl as string,
              name: sourceAsset.name as string,
            }
          : undefined
      }
      title={content?.title ?? ''}
      description={content?.subtitle || content?.statusContent || null}
      onClose={handleClose}
      poweredByText={content?.poweredByText}
      goToPortfolioBtnVariant="primary"
      disableOverlayClose
      closeIconShouldRedirectToPortfolio
      isBpfs={isBpfs}
    />
  );
};
